// Shared inventory API config (safe even if other files exist)
window.INVENTORY_API_CONFIG = window.INVENTORY_API_CONFIG || {
    "la-apparel-dev.myshopify.com": { apiBase: "https://laapparel.co/main/laa/shopify/inventory/", env: "dev" },
    "losangelesapparel.net": { apiBase: "https://laapparel.co/main/laa/shopify/inventory/", env: "prod" },
  };
  
  window.getAimsConfig =
    window.getAimsConfig ||
    function () {
      return (
        window.INVENTORY_API_CONFIG[window.location.hostname] ||
        window.INVENTORY_API_CONFIG["losangelesapparel.net"]
      );
    };
  
  "undefined" === typeof Shopify && (window.Shopify = {});
  "undefined" === typeof Shopify.getCart &&
    (Shopify.getCart = function (a, b) {
      if (!b)
        return jQuery.getJSON("/cart.js", function (c, d, e) {
          if ("function" === typeof a) a(c, d, e);
          else Shopify.onCartUpdate(c);
        });
      if ("function" === typeof a) a(b);
      else if ("function" === typeof Shopify.onCartUpdate) Shopify.onCartUpdate(b);
    });
  
  customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector("form");
          if (!this.form) return;
  
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cartNotification = document.querySelector("cart-notification");
  
          // -------------------------------
          // Pickup-only label wiring
          // -------------------------------
          this._pickupOnlyInitialized = false;
          this._lastVariantIdForPickupOnly = null;
          this._pickupOnlyAbort = null;
          this._pickupOnlyTimer = null;
  
          // NEW: make rerenders safe + prevent flicker
          this._pickupCache = new Map(); // variantId -> "add" | "pickup"
          this._buttonWasReplaced = false;
          this._formObserver = null;
  
          this.initPickupOnlyButtonLabel();
        }
  
        disconnectedCallback() {
          if (this._onVariantInteraction) {
            document.removeEventListener("change", this._onVariantInteraction, true);
            document.removeEventListener("click", this._onVariantInteraction, true);
          }
          if (this._idObserver) this._idObserver.disconnect();
          if (this._formObserver) this._formObserver.disconnect();
          if (this._pickupOnlyAbort) this._pickupOnlyAbort.abort();
          if (this._pickupOnlyTimer) clearTimeout(this._pickupOnlyTimer);
  
          this._formObserver = null;
        }
  
        // NEW: re-grab button refs after VariantSelects replaces form HTML
        refreshButtonRefs() {
          const btn =
            this.querySelector('button[name="add"][type="submit"]') ||
            this.querySelector('button[type="submit"]');
  
          if (!btn) return false;
  
          const changed = btn !== this.submitBtn;
          this.submitBtn = btn;
          this.submitTextEl = btn.querySelector(".product-form__submit-text") || btn;
  
          // Re-read labels + location from the (possibly new) button
          this.labelAdd = btn.dataset.addToCartText || this.labelAdd || "Add to Cart";
          this.labelPickupOnly = btn.dataset.storePickupOnlyText || this.labelPickupOnly || "Store Pickup Only";
          this.labelSoldOut = btn.dataset.soldOutText || this.labelSoldOut || "Sold out";
          this.pickupCheckLocationId = btn.dataset.pickupCheckLocationId || this.pickupCheckLocationId || "40790086";
  
          if (changed) this._buttonWasReplaced = true;
          return changed;
        }
  
        initPickupOnlyButtonLabel() {
          if (this._pickupOnlyInitialized) return;
          this._pickupOnlyInitialized = true;
  
          // IMPORTANT: always pull fresh refs (VariantSelects can replace markup)
          this.refreshButtonRefs();
          if (!this.submitBtn) return;
  
          // Run once on load
          this.updatePickupOnlyLabel();
  
          // Catch most variant changes (buttons/swatches/selects)
          this._onVariantInteraction = () => this.debouncedUpdatePickupOnlyLabel();
          document.addEventListener("change", this._onVariantInteraction, true);
          document.addEventListener("click", this._onVariantInteraction, true);
  
          // Some themes set input.value without updating the attribute.
          const idInput = this.form?.querySelector('input[name="id"]');
          if (idInput) {
            this._idObserver = new MutationObserver(() => this.debouncedUpdatePickupOnlyLabel());
            this._idObserver.observe(idInput, { attributes: true, attributeFilter: ["value"] });
          }
  
          // NEW: watch for innerHTML replacement (your VariantSelects does this)
          if (!this._formObserver) {
            this._formObserver = new MutationObserver(() => {
              const changed = this.refreshButtonRefs();
              if (changed) {
                // Force re-check even if variant id didn't change
                this._lastVariantIdForPickupOnly = null;
                this.debouncedUpdatePickupOnlyLabel();
              }
            });
            this._formObserver.observe(this.form, { childList: true, subtree: true });
          }
        }
  
        debouncedUpdatePickupOnlyLabel() {
          if (this._pickupOnlyTimer) clearTimeout(this._pickupOnlyTimer);
          // tiny delay lets theme finish swapping variant id + form HTML before we read it
          this._pickupOnlyTimer = setTimeout(() => this.updatePickupOnlyLabel(), 80);
        }
  
        getCurrentVariantId() {
          const idInput = this.form?.querySelector('input[name="id"]');
          const v = idInput?.value;
          return v ? String(v) : null;
        }
  
        setSubmitLabel(mode) {
          // mode: "add" | "pickup"
          this.refreshButtonRefs();
          if (!this.submitTextEl || !this.submitBtn) return;
  
          const next = mode === "pickup" ? this.labelPickupOnly : this.labelAdd;
  
          if (this.submitTextEl.textContent.trim() !== next) {
            this.submitTextEl.textContent = next;
          }
  
          // marker for other scripts to respect
          this.submitBtn.toggleAttribute("data-store-pickup-only", mode === "pickup");
        }
  
        async updatePickupOnlyLabel() {
          // TEMP FIX: always show "Add to Cart" — revert this when ready
          this.refreshButtonRefs();
          if (this.submitBtn) this.setSubmitLabel("add");
          return;
          if (!this.submitBtn) return;
  
          const variantId = this.getCurrentVariantId();
          if (!variantId) return;
  
          // Don't override sold-out/disabled state from Shopify availability
          if (this.submitBtn.hasAttribute("disabled")) return;
  
          // Apply cached result immediately (prevents flicker after rerender)
          const cachedMode = this._pickupCache.get(variantId);
          if (cachedMode) this.setSubmitLabel(cachedMode);
  
          // If variant hasn't changed AND button wasn't replaced, no-op
          if (variantId === this._lastVariantIdForPickupOnly && !this._buttonWasReplaced) return;
  
          this._lastVariantIdForPickupOnly = variantId;
          this._buttonWasReplaced = false;
  
          if (this._pickupOnlyAbort) this._pickupOnlyAbort.abort();
          this._pickupOnlyAbort = new AbortController();
  
          const { apiBase, env } = window.getAimsConfig();
          const url = `${apiBase}${variantId}?env=${env}`;
  
          try {
            const res = await fetch(url, { signal: this._pickupOnlyAbort.signal });
            if (!res.ok) throw new Error(res.statusText);
            const data = await res.json();
  
            const inv = data.inventory || [];
            const target = inv.find((loc) =>
              String(loc.location_id || "").endsWith(`/${this.pickupCheckLocationId}`)
            );
  
            const qty = Number(target?.quantities?.available ?? 0);
            const mode = qty <= 0 ? "pickup" : "add";
  
            this._pickupCache.set(variantId, mode);
            this.setSubmitLabel(mode);
          } catch (err) {
            if (err?.name === "AbortError") return;
            console.error("Pickup-only label check failed:", err);
  
            // IMPORTANT: don't "fail open" to Add to Cart here,
            // otherwise rerenders / blocked fetches will flip pickup -> add.
            // If we had a cachedMode, it's already applied above.
          }
        }
  
        // ---------- Your existing submit handler ----------
        onSubmitHandler(a) {
          a.preventDefault();
  
          this.cartNotification?.setActiveElement?.(document.activeElement);
  
          const b =
            this.querySelector('button[name="add"][type="submit"]') ||
            this.querySelector('[type="submit"]');
  
          b.setAttribute("disabled", !0);
          b.classList.add("loading");
  
          window.frenzyCartProperties = {
            _event_name: "pdp_add_to_cart",
            _user_id: user_id_Frenzy ? user_id_Frenzy.toString() : null,
          };
  
          const formData = {
            ...JSON.parse(serializeForm(this.form)),
            properties: { ...window.frenzyCartProperties },
          };
  
          a = JSON.stringify(formData);
  
          fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body: a })
            .then((c) => c.json())
            .then(() => {
              Shopify.getCart(function () {
                Shopify.AjaxCart.api.updateCart();
              });
              frenzyAsyncItems();
            })
            .catch((c) => {
              console.error(c);
            })
            .finally(() => {
              b.classList.remove("loading");
              b.removeAttribute("disabled");
              Shopify.AjaxCart.functions.cartOpen();
  
              // After cart open, re-check label (safety)
              this.debouncedUpdatePickupOnlyLabel();
            });
        }
      }
    );
  